import { DalState, UserQueries } from '@campus/dal';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import {
  ContentTaskActionsDefaultService,
  ContentTaskActionsService,
  ContentTaskActionsServiceInterface,
  ContentTaskActionsStudentService,
  ContentTaskManagerInterface,
} from '../services';

export function ContentTaskActionServiceFactory(
  store: Store<DalState>,
  contentTaskManager?: ContentTaskManagerInterface
): ContentTaskActionsServiceInterface {
  if (!contentTaskManager) return new ContentTaskActionsDefaultService();

  let isTeacher = false;
  store.pipe(select(UserQueries.getCurrentUser), take(1)).subscribe((user) => {
    isTeacher = (user?.roles || []).some((role) => role.name === 'teacher');
  });

  return isTeacher
    ? new ContentTaskActionsService(contentTaskManager)
    : new ContentTaskActionsStudentService(contentTaskManager);
}
